import { genreTags, navLinks } from "@/mocks/movies";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center text-lg font-bold">
                八
              </span>
              <span className="font-heading text-xl font-bold">八戒影院</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200 max-w-md">
              八戒影院聚合最新电影、电视剧大全与好看的片推荐，设有伦理片、中文字幕与高清资源专区，
              按片单分类帮助不同类型的观众快速找到想看的内容。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["中文字幕", "高清资源", "每日更新", "多端浏览"].map((t) => (
                <span
                  key={t}
                  className="px-3 py-1 rounded-full bg-secondary-800 text-background-100 text-xs"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
              内容分区
            </h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-200 hover:text-primary-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">
              热门题材
            </h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {genreTags.slice(0, 12).map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded-md bg-secondary-800/70 text-background-200 text-xs"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            本站为影视片单信息展示页面，内容仅供浏览参考。
          </p>
          <p className="text-xs text-background-300">© 2026 八戒影院 · 保留所有权利</p>
        </div>
      </div>
    </footer>
  );
}